/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBubbleMessageAttention: {
  name: 'bubble-message-attention';
  data: string;
} = {
  name: 'bubble-message-attention',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8.277l-4.762 2.858A1 1 0 0 1 2 21V5Zm18 0H4v14.234l3.248-1.949A2 2 0 0 1 8.277 17H20V5Zm-7 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0-6a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0V8Z" fill="currentColor"/></svg>`,
};
